import React from 'react';

/** Platzhalter-Zeilen, die beim Laden die Spalten der Tabelle andeuten — statt eines Spinners
 *  im leeren Raum. Die Balkenbreiten variieren pro Zeile, damit es nicht wie ein Raster wirkt. */
const BAR_WIDTHS = ['w-3/4', 'w-1/2', 'w-2/3', 'w-5/6', 'w-2/5'];

function barWidth(row: number, col: number): string {
  return BAR_WIDTHS[(row * 3 + col * 5) % BAR_WIDTHS.length];
}

export function TableSkeletonRows({
  columns,
  rows = 8,
  label = 'Wird geladen …',
}: {
  columns: number;
  rows?: number;
  label?: string;
}) {
  return (
    <>
      {Array.from({ length: rows }, (_, r) => (
        <tr
          key={r}
          className="animate-pulse border-b border-app-border"
          aria-hidden={r > 0 ? true : undefined}
          aria-label={r === 0 ? label : undefined}
          role={r === 0 ? 'status' : undefined}
        >
          {Array.from({ length: columns }, (_, c) => (
            <td key={c} className="px-3 py-3">
              <div className={`h-3 rounded bg-slate-200 ${barWidth(r, c)}`} />
            </td>
          ))}
        </tr>
      ))}
    </>
  );
}

/** Gegenstück für die mobile Kartenliste: zwei Textzeilen links, ein Wert rechts. */
export function CardListSkeleton({ rows = 6, label = 'Wird geladen …' }: { rows?: number; label?: string }) {
  return (
    <div className="divide-y divide-app-border animate-pulse" role="status" aria-label={label}>
      {Array.from({ length: rows }, (_, r) => (
        <div key={r} className="flex items-start gap-3 px-4 py-3">
          <div className="min-w-0 flex-1 space-y-2">
            <div className={`h-3.5 rounded bg-slate-200 ${barWidth(r, 0)}`} />
            <div className={`h-3 rounded bg-slate-200 ${barWidth(r, 1)}`} />
          </div>
          <div className="w-16 shrink-0 space-y-2">
            <div className="ml-auto h-3.5 w-14 rounded bg-slate-200" />
            <div className="ml-auto h-3 w-10 rounded bg-slate-200" />
          </div>
        </div>
      ))}
    </div>
  );
}
